import React, { FC, useEffect, useState } from "react";

import Users from "./Users/Users";
import Roles from "./Roles/Roles";
import { Link, Route, Switch, useHistory, useLocation, useRouteMatch } from "react-router-dom";

import "../../styles/index.scss";
import "./UserBase.scss";
import Header from "@components/Header";
import { HeaderTab } from "@components/HeaderTab";
import { HeaderText } from "@components/HeaderText";
import { ListContainer } from "@components/ListContainer";
import { useFormatMessage } from "@hooks/formatMessage";

const tabs = [
  { path: "users", renderComponent: props => <Users {...props} /> },
  { path: "roles", renderComponent: props => <Roles {...props} /> },
];

const UserBase: FC = () => {
  const [currentTab, setCurrentTab] = useState("");
  const { path, url } = useRouteMatch();
  const formatMessage = useFormatMessage();
  const history = useHistory();
  const location = useLocation();
  const state = location.state as Record<string, string>;

  useEffect(() => {
    if (state) {
      setCurrentTab(state.currentTab);
    }
  }, [state]);

  return (
    <ListContainer>
      <Header title="Users">
        {tabs.map(tab => (
          <HeaderTab active={currentTab === tab.path}>
            <Link to={{ pathname: `${url}/${tab.path}`, state: { currentTab: tab.path } }}>
              <HeaderText active={currentTab === tab.path}>
                {formatMessage(`${tab.path}`)}
              </HeaderText>
            </Link>
          </HeaderTab>
        ))}
      </Header>
      <Switch>
        {tabs.map(tab => (
          <Route path={`${path}/${tab.path}`}>{tab.renderComponent({ location, history })}</Route>
        ))}
      </Switch>
    </ListContainer>
  );
};

export default UserBase;
